/**
 * Core Web Vitals Tracking
 * LCP < 2.5s, CLS < 0.1, INP < 200ms
 */

import { onCLS, onLCP, onFCP, onTTFB, onINP } from 'web-vitals';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Store vitals in memory for admin panel
let vitalsData = {
  LCP: null,
  CLS: null,
  INP: null,
  FCP: null,
  TTFB: null,
  timestamp: null,
  page: null
};

// Thresholds for good performance
const THRESHOLDS = {
  LCP: { good: 2500, needsImprovement: 4000 },  // ms
  CLS: { good: 0.1, needsImprovement: 0.25 },   // score
  INP: { good: 200, needsImprovement: 500 },    // ms (replaced FID)
  FCP: { good: 1800, needsImprovement: 3000 },  // ms
  TTFB: { good: 800, needsImprovement: 1800 }   // ms
};

const getRating = (name, value) => {
  const threshold = THRESHOLDS[name];
  if (!threshold) return 'unknown';
  if (value <= threshold.good) return 'good';
  if (value <= threshold.needsImprovement) return 'needs-improvement';
  return 'poor';
};

const sendToAnalytics = async (metric) => {
  // Update local storage
  vitalsData[metric.name] = {
    value: metric.value,
    rating: getRating(metric.name, metric.value),
    delta: metric.delta,
    id: metric.id
  };
  vitalsData.timestamp = Date.now();
  vitalsData.page = window.location.pathname;

  // Send to backend for admin monitoring
  try {
    await fetch(`${API_URL}/api/admin/web-vitals`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: metric.name,
        value: metric.value,
        rating: getRating(metric.name, metric.value),
        page: window.location.pathname,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString()
      })
    });
  } catch (e) {
    // Silent fail - don't block user experience
  }

  // Also send to GTM if available
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'web_vitals',
      metric_name: metric.name,
      metric_value: Math.round(metric.value),
      metric_rating: getRating(metric.name, metric.value)
    });
  }
};

export const initWebVitals = () => {
  onCLS(sendToAnalytics);
  onINP(sendToAnalytics);
  onLCP(sendToAnalytics);
  onFCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
};

export const getVitalsData = () => vitalsData;
export const VITALS_THRESHOLDS = THRESHOLDS;
